<template>
  <section>
    <!-- Careers -->
          <div id="careers" >
            <div class="careers_banner"></div>
      <div class="container page">
        <div class="section-title center" >
          <h2 class="text-center"><strong>Careers</strong></h2>
          <div class="line"></div>
          <div class="clearfix"></div>
          <h3 class="text-center"><strong>Let's work together!</strong></h3>
          <p class="intro text-center">
            <em>We are committed in finding the best fit for our clients and candidates. We are an equal opportunity employer that recognize that our people are our greatest asset. With a rapidly growing list of clients we are constantly in search of new talented professionals. Let's work together and find the right fit for you.
            </em>
          </p>
        </div>
        <div class="col-md-12">
        <!-- Current Openings -->
        <current />
        <!-- General jobs -->
        <div class="row">
        <p>Not ready to apply or don’t see the right opportunity? We are always in lookout for new talent contact us and we can work together to find that right fit for you. <br></p>
          <a href="/contact"><button type="button" class="btn btn-primary"> Contact Us </button></a><br>
        </div>
          <div class="row">
          <br>
          <p><strong>We place skilled professionals across a range of specializations incluing:</strong></p>

              <div class="col-md-4 col-sm-6">
      <ul class="about-list">
        <li><em>Full Stack Development</em></li>
        <li><em>ERP Technical/Functional</em></li>
        <li><em>Software engineering</em></li>
        <li><em>Project Management</em></li>
      </ul>
  </div>
              <div class="col-md-4 col-sm-6">
      <ul class="about-list">
        <li><em>Business/Systems/Data Analysts</em></li>
        <li><em>Front End Developments</em></li>
        <li><em>UI/UX Design</em></li>
        <li><em>Data Warehousing</em></li>
      </ul>
  </div>
              <div class="col-md-4 col-sm-6">
  <ul class="about-list">
        <li><em>Network Engineering</em></li>
        <li><em>Cyber Security</em></li>
        <li><em>Cloud Engineering/Architecture</em></li>
        <li><em>Devops</em></li>
      </ul>
  </div>

</div>
          <div class="space"></div>
        </div>
      </div>
    </div>
  </section>
</template>


<script>
  import current from "./current_openings.vue"
  export default {
    components: {
      current
    }
  };
</script>



